module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/treviso.5501b438e928a8b38e6e274f460b6b93.jpg";